import { A_Error } from "@adaas/a-concept"


export class A_ResponseError extends A_Error {

}